const localeAliases = {
  'zh-cn': 'zh-CN', 'zh-hans': 'zh-CN', zh: 'zh-CN',
  'zh-tw': 'zh-TW', 'zh-hant': 'zh-TW', tw: 'zh-TW',
  en: 'en', 'en-us': 'en', 'en-gb': 'en',
  ja: 'ja_JP', 'ja-jp': 'ja_JP', vi: 'vi_VN', 'vi-vn': 'vi_VN',
}

export function normalizeSharedLocale(value) {
  return typeof value === 'string' ? localeAliases[value.trim().replaceAll('_', '-').toLowerCase()] || '' : ''
}

export function buildLocalizedShareUrl(href, locale) {
  const url = new URL(href)
  const normalized = normalizeSharedLocale(locale)
  if (normalized) url.searchParams.set('locale', normalized)
  return url.toString()
}
